<div class="p-2 p-sm-4">
    <div class="d-flex flex-column border p-3 shadow-sm bg-white rounded gap-3">
        <div class="d-flex flex-sm-row flex-column gap-2 flex-wrap">
            <div class="form-group">
                <label for="desde">Desde: </label>
                <input type="datetime-local" class="form-control" id="desde" [(ngModel)]="desde">
            </div>
            <div class="form-group">
                <label for="hasta">Hasta: </label>
                <input type="datetime-local" class="form-control" id="hasta" [(ngModel)]="hasta">
            </div>
            <div class="form-group col-12 col-lg">
                <label for="productos">Productos</label>
                <ng-select [items]="productos" bindValue="id" [(ngModel)]="productosSelected" labelForId="productos" [searchFn]="searchFn" [virtualScroll]="true" bindLabel="nombre" [multiple]="true">
                    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                        {{item.nombre}}
                    </ng-template>
                </ng-select>
            </div>
            <div class="mt-4 mb-auto">
                <button class="btn btn-primary" (click)="loadData()"><i class="fas fa-redo"></i> Recargar</button>
            </div>
        </div>

        <div class="d-flex gap-5">
            <div class="mb-3">
                <div class="btn-group" role="group" aria-label="Basic example">
                    <button type="button" class="btn btn-primary" [ngClass]="{'active': tipoVista == 1}"
                        (click)="tipoVista = 1; loadData()">Día</button>
                    <button type="button" class="btn btn-primary" [ngClass]="{'active': tipoVista == 2}"
                        (click)="tipoVista = 2; loadData()">Mes</button>
                    <button type="button" class="btn btn-primary" [ngClass]="{'active': tipoVista == 3}"
                        (click)="tipoVista = 3; loadData()">Año</button>
                </div>
            </div>
            <div class="mb-3">
                <div class="btn-group" role="group" aria-label="Basic example">
                    <button type="button" class="btn btn-primary" [ngClass]="{'active': filtroFecha == 2}"
                        (click)="setFiltroFecha(2)">Este día</button>
                    <button type="button" class="btn btn-primary" [ngClass]="{'active': filtroFecha == 3}"
                        (click)="setFiltroFecha(3)">Este mes</button>
                    <button type="button" class="btn btn-primary" [ngClass]="{'active': filtroFecha == 4}"
                        (click)="setFiltroFecha(4)">Mes pasado</button>
                    <button type="button" class="btn btn-primary" [ngClass]="{'active': filtroFecha == 5}"
                        (click)="setFiltroFecha(5)">Este año</button>
                    <button type="button" class="btn btn-primary" [ngClass]="{'active': filtroFecha == 6}"
                        (click)="setFiltroFecha(6)">Año pasado</button>
                </div>
            </div>
        </div>

        <div class="d-flex flex-sm-row flex-column gap-2">
            <div class="border p-3 shadow-sm d-flex flex-column bg-white rounded w-50">
                <h5>Productos más vendidos</h5>
                <table class="table table-xs">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Producto</th>
                            <th scope="col">Cantidad</th>
                            <th scope="col">Valor</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of data.productosMasVendidos; let index = index">
                            <th scope="row">{{index+1}}</th>
                            <td>{{item.nombre}}</td>
                            <td>{{formatter.numberFormat(item.cantidad)}}</td>
                            <td>{{formatter.numberFormat(item.monto)}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="border p-3 shadow-sm bg-white rounded w-100">
                <h5>Stock de los productos</h5>
                <div class="w-100">
                    <canvas id="stocks" class="w-100" style="height: 300px;"></canvas>
                </div>
            </div>
        </div>

        <div class="d-flex flex-sm-row flex-column gap-2">
            <div class="border p-3 shadow-sm d-flex flex-column bg-white rounded w-50">
                <h5>Productos Mayor Ingreso</h5>
                <table class="table table-xs">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Producto</th>
                            <th scope="col">Ventas</th>
                            <th scope="col">Ventas - Costo</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of data.productosMasVentas; let index = index">
                            <th scope="row">{{index+1}}</th>
                            <td>{{item.nombre}}</td>
                            <td>{{formatter.numberFormat(item.ventas)}}</td>
                            <td>{{formatter.numberFormat(item.monto)}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="border p-3 shadow-sm d-flex flex-column bg-white rounded w-100">
                <h5>Compra vs Venta de productos</h5>
                <div class="w-100">
                    <canvas id="compra-venta" class="w-100" style="height: 300px;"></canvas>
                </div>
            </div>
        </div>

        <div class="d-flex flex-sm-row flex-column gap-2">
            <div class="border p-3 shadow-sm d-flex flex-column bg-white rounded w-100">
                <h5>Productos Menos Vendidos</h5>
                <table class="table table-xs">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Producto</th>
                            <th scope="col">Cantidad</th>
                            <th scope="col">Valor</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of data.productosMenosVendidos; let index = index">
                            <th scope="row">{{index+1}}</th>
                            <td>{{item.nombre}}</td>
                            <td>{{formatter.numberFormat(item.cantidad)}}</td>
                            <td>{{formatter.numberFormat(item.monto)}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="border p-3 shadow-sm d-flex flex-column bg-white rounded w-100">
                <h5>Productos bajo stock</h5>
                <table class="table table-xs">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Producto</th>
                            <th scope="col">Cantidad Faltante</th>
                            <th scope="col">Valor</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of data.productosBajoStock; let index = index">
                            <th scope="row">{{index+1}}</th>
                            <td>{{item.nombre}}</td>
                            <td>{{formatter.numberFormat(item.stock_minimo - item.cantidad)}}</td>
                            <td>{{formatter.numberFormat((item.stock_minimo - item.cantidad) * item.precio_compra)}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>